(function () {
  'use strict';

  function shouldShowToolbar() {
    if (window.Shopify && window.Shopify.designMode) return true;

    if (document.querySelector('#PBarNextFrameWrapper, #admin-bar-iframe')) return true;

    try {
      if (new URLSearchParams(window.location.search).has('lgk_staff')) {
        sessionStorage.setItem('lgk_staff', '1');
      }
      if (sessionStorage.getItem('lgk_staff') === '1') return true;
    } catch (e) {
      /* ignore */
    }

    return false;
  }

  function init() {
    var toolbar = document.querySelector('[data-lgk-staff-toolbar]');
    if (!toolbar) return;

    if (toolbar.dataset.designMode === 'true' || shouldShowToolbar()) {
      toolbar.hidden = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.setTimeout(init, 1200);
})();
